import { Component, OnInit } from '@angular/core';

import { NotyService } from '../../../services/common/noty.service';
import { SidekiqService } from '../../../services/common/sidekiq.service';

@Component({
  selector: 'app-sidekiq-index',
  templateUrl: './sidekiq-index.component.html',
  styleUrls: ['./sidekiq-index.component.scss'],
})
export class SidekiqIndexComponent implements OnInit {
  cronJobs: Array<any> = [];

  loadingCron: boolean = true;

  loadingSidekiqInfo: boolean = true;

  reminderCronPresent: boolean = true;

  sidekiqInfo: any = {};

  constructor(private notyService: NotyService, private sidekiqService: SidekiqService) {}

  // Component lifecycle methods
  ngOnInit() {
    this.loadCronJobs();
    this.loadSidekiqInfo();
  }

  // Component methods
  destroyCron(cronJob: any) {
    cronJob.processing = true;
    this.sidekiqService
      .destroyCron(cronJob.name)
      .then((response_json) => {
        cronJob.processing = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Cron destroyed', 'success');
          this.loadCronJobs();
        } else this.notyService.notify(response_json.text || 'Error destroying cron', 'error');
      })
      .catch(() => {
        cronJob.processing = false;
        this.notyService.notify('Error destroying cron', 'error');
      });
  }

  disableCron(cronJob: any) {
    cronJob.processing = true;
    this.sidekiqService
      .disableCron(cronJob.name)
      .then((response_json) => {
        cronJob.processing = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Cron disabled', 'success');
          this.loadCronJobs();
        } else this.notyService.notify(response_json.text || 'Error disabling cron', 'error');
      })
      .catch(() => {
        cronJob.processing = false;
        this.notyService.notify('Error disabling cron', 'error');
      });
  }

  enableCron(cronJob: any) {
    cronJob.processing = true;
    this.sidekiqService
      .enableCron(cronJob.name)
      .then((response_json) => {
        cronJob.processing = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Cron enabled', 'success');
          this.loadCronJobs();
        } else this.notyService.notify(response_json.text || 'Error enabling cron', 'error');
      })
      .catch(() => {
        cronJob.processing = false;
        this.notyService.notify('Error enabling cron', 'error');
      });
  }

  enqueCron(cronJob: any) {
    cronJob.processing = true;
    this.sidekiqService
      .enqueCron(cronJob.name)
      .then((response_json) => {
        cronJob.processing = false;
        if (response_json.success) this.notyService.notify(response_json.text || 'Cron enqued', 'success');
        else this.notyService.notify(response_json.text || 'Error enquing cron', 'error');
      })
      .catch(() => {
        cronJob.processing = false;
        this.notyService.notify('Error enquing cron', 'error');
      });
  }

  loadCronJobs() {
    this.loadingCron = true;
    this.sidekiqService
      .sidekiqCronInfo()
      .then((response_json) => {
        this.loadingCron = false;
        this.cronJobs = response_json.cron_jobs;
        for (let cronJob of this.cronJobs)
          if (cronJob.name == 'Send out reminders') {
            this.reminderCronPresent = true;
            return;
          }
        this.reminderCronPresent = false;
      })
      .catch(() => {
        this.loadingCron = false;
        this.notyService.notify('Error loading cron job details', 'error');
      });
  }

  loadSidekiqInfo() {
    this.loadingSidekiqInfo = true;
    this.sidekiqService
      .sidekiqInfo()
      .then((response_json) => {
        this.loadingSidekiqInfo = false;
        this.sidekiqInfo = response_json;
      })
      .catch(() => {
        this.loadingSidekiqInfo = false;
      });
  }

  startReminderCron() {
    this.loadingCron = true;
    this.sidekiqService
      .createReminderCron()
      .then((response_json) => {
        this.loadingCron = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Reminder cron started', 'success');
          this.loadCronJobs();
        } else this.notyService.notify(response_json.text || 'Error starting reminder cron', 'error');
      })
      .catch(() => {
        this.loadingCron = false;
        this.notyService.notify('Error starting reminder cron', 'error');
      });
  }
}
